import { Tag } from '../types/audience.types';

/**
 * Combine include and exclude tags for API submission
 */
export const combineTags = (includeTags: Tag[], excludeTags: Tag[]): Tag[] => {
    const tags: Tag[] = [...includeTags];
    excludeTags.forEach(tag => {
        tags.push({ ...tag, excluded: 1 });
    });
    return tags;
};

/**
 * Format tags for API submission (extract just the names)
 */
export const formatTagsForAPI = (tags: Tag[]): string[] => {
    return tags.filter(t => !t.excluded).map(t => t.name);
};

/**
 * Separate combined tags into include and exclude arrays
 */
export const separateTags = (tags: Tag[]): { includeTags: Tag[]; excludeTags: Tag[] } => {
    const includeTags = tags.filter(tag => !tag.excluded);
    const excludeTags = tags.filter(tag => tag.excluded);
    return { includeTags, excludeTags };
};
